module.exports = __webpack_public_path__ + "static/media/photo307.40066dc6.jpg";